import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IOneMeetingAgendaPayload } from '@app-store/slices/meetingAgenda/oneMeeting'

interface TaskAction extends Action {
    payload: IOneMeetingAgendaPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.meetingAgenda.oneMeeting

function* getOneMeetingAgendaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/meeting/one/${payload.meetingId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            if (payload?.sagaCB?.onSuccess) payload.sagaCB.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* getMeetingAgenda(): any {
    yield takeLatest<TaskAction>(onRequest, getOneMeetingAgendaTask)
}

export default getMeetingAgenda
